import { Link } from "react-router-dom";
import { NEWS, NEWS_CATEGORY_LABELS } from "@/mocks/news";
import SectionHeading from "@/components/base/SectionHeading";

export default function NewsBrief() {
  const sorted = [...NEWS].sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
  const featured = sorted[0];
  const rest = sorted.slice(1, 5);

  if (!featured) return null;

  return (
    <section>
      <SectionHeading title="最新影视资讯" subtitle="行业动态、片场花絮与深度评论" moreLink="/news" />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* 主推资讯 */}
        <Link
          to={`/news/${featured.id}`}
          className="group relative h-72 overflow-hidden rounded-lg bg-primary-950 lg:h-full lg:min-h-[380px]"
        >
          <img
            src={featured.cover}
            alt={featured.title}
            title={`${featured.title} - WWW.17C`}
            className="h-full w-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/40 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-6">
            <span className="mb-2 inline-block rounded-md bg-accent-500 px-2.5 py-1 text-xs font-semibold text-primary-950">
              {NEWS_CATEGORY_LABELS[featured.category]}
            </span>
            <h3 className="font-heading text-lg font-bold leading-snug text-background-50 transition-colors group-hover:text-accent-400 md:text-xl">
              {featured.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm text-background-300">{featured.summary}</p>
            <p className="mt-3 flex items-center gap-3 text-xs text-background-400">
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {featured.publishedAt}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-newspaper-line"></i>
                {featured.source}
              </span>
            </p>
          </div>
        </Link>

        {/* 资讯列表 */}
        <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/news/${item.id}`}
              className="group flex flex-col gap-1.5 p-4 transition-colors hover:bg-background-100"
            >
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-50 px-2 py-0.5 font-medium text-secondary-700">
                  {NEWS_CATEGORY_LABELS[item.category]}
                </span>
                <span>{item.publishedAt}</span>
              </div>
              <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                {item.title}
              </h3>
            </Link>
          ))}
          <Link
            to="/news"
            className="flex items-center justify-center gap-1 p-4 text-sm font-medium text-secondary-600 transition-colors hover:bg-background-100"
          >
            浏览全部资讯
            <i className="ri-arrow-right-s-line text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}